const onRun = () => {
    // Line Top Offers
    const lineTopOffersWrap = document.querySelector('.line-top-offers');

    if (lineTopOffersWrap !== null) {
        const lineTopOffersItems = Array.from(document.querySelectorAll('.line-top-offers-item'));
        const lineTopOffersColumns = Array.from(lineTopOffersWrap.querySelectorAll('.line-top-offers__column'));
        const lineTopOffersButton = lineTopOffersWrap.querySelector('.line-top-offers__button button');

        // Function to hide/show offers based on the selected country
        function handleHideAllCountries() {
            lineTopOffersItems.forEach((lineTopOffer) => {
                lineTopOffer.classList.add('hidden');
            });
        }

        const showCountryOffers = (countryIdToShow) => {
            lineTopOffersItems.forEach((lineTopOffer) => {
                const countryId = lineTopOffer.dataset.countryId;

                if (countryIdToShow === countryId || countryIdToShow === 'all') {
                    lineTopOffer.classList.remove('hidden');
                }
            });
        }

        // Function to hide columns if there is only one visible item
        function hideEmptyColumns() {
            lineTopOffersColumns.forEach((column) => {
                const visibleItems = Array.from(column.querySelectorAll('.line-top-offers-item:not(.hidden)'));
                if (visibleItems.length <= 1) {
                    column.classList.add('hidden');
                } else {
                    column.classList.remove('hidden');
                }
            });
        }

        // Function to check and add js-show-more-items class
        function checkAllDisplayed() {
            const visibleItems = Array.from(lineTopOffersWrap.querySelectorAll('.line-top-offers-item:not(.hidden)'));
            if (visibleItems.length <= 6) {
                lineTopOffersWrap.classList.add('js-show-all');
                lineTopOffersButton.classList.add('hidden');
            } else {
                lineTopOffersWrap.classList.remove('js-show-all');
                lineTopOffersButton.classList.remove('hidden');
            }
        }

        function toggleButtonText() {
            const isShowed = lineTopOffersWrap.classList.contains('js-show-all');
            if (isShowed) {
                lineTopOffersButton.textContent = 'Zobraziť menej';
            } else {
                lineTopOffersButton.textContent = 'Zobraziť všetky';
            }
        }

        // Event handler for "Show More" button
        lineTopOffersButton.addEventListener('click', function () {
            lineTopOffersWrap.classList.toggle('js-show-all');

            toggleButtonText();
            hideEmptyColumns();
        });

        // Event handler for both the badges and the select element
        function handleCountrySelection(countryId) {
            handleHideAllCountries();
            showCountryOffers(countryId);
            hideEmptyColumns();
            checkAllDisplayed();
            toggleButtonText();
        }

        // Attach click event listener to each badge
        const lineTopOffersBadges = document.querySelector('.top-offers__badges');
        lineTopOffersBadges.addEventListener('click', function (event) {
            const badge = event.target.closest('.btn');

            if (badge) {
                lineTopOffersBadges.querySelector('.is-active').classList.remove('is-active');
                badge.classList.add('is-active');

                handleCountrySelection(badge.dataset.id);
            }
        });

        // Attach change event listener to the select element
        const lineTopOffersSelect = document.querySelector('.top-offers__select');
        if (lineTopOffersSelect) {
            const lineTopOffersSelectOptions = lineTopOffersSelect.querySelectorAll('option');
            lineTopOffersSelect.addEventListener('change', function () {
                const countryId = this.value;

                lineTopOffersSelectOptions.forEach((option) => {
                    option.selected = option.value === countryId;
                });

                handleCountrySelection(countryId);
            });
        }

        // Initial setup
        handleHideAllCountries();
        showCountryOffers('all');
        hideEmptyColumns();
        checkAllDisplayed();
    }
};
if (document.readyState !== 'loading') {
    onRun();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        onRun()
    });
}

